"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _templateObject = _taggedTemplateLiteral(["\n  position: absolute;\n  text-align: left;\n  bottom: 20px;\n  font-family: ", ";\n  font-weight: ", ";\n  ", ";\n  color: white;\n  background-color: ", ";\n  border-radius: 4px;\n  width: 230px;\n  padding: 8px 12px;\n  transition: opacity 0.3s;\n  box-sizing: border-box;\n  z-index: 1000;\n  visibility: ", ";\n  margin: 0 50%;\n  transform: ", ";\n  \n  ", "\n"], ["\n  position: absolute;\n  text-align: left;\n  bottom: 20px;\n  font-family: ", ";\n  font-weight: ", ";\n  ", ";\n  color: white;\n  background-color: ", ";\n  border-radius: 4px;\n  width: 230px;\n  padding: 8px 12px;\n  transition: opacity 0.3s;\n  box-sizing: border-box;\n  z-index: 1000;\n  visibility: ", ";\n  margin: 0 50%;\n  transform: ", ";\n  \n  ", "\n"]),
    _templateObject2 = _taggedTemplateLiteral(["\n    bottom: unset;\n    top: 20px;\n  "], ["\n    bottom: unset;\n    top: 20px;\n  "]);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _buoyTheme = require("buoy-theme");

var _buoyText = require("buoy-text");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var PopoverMessage = (0, _styledComponents2.default)(_buoyText.Paragraph).withConfig({
  displayName: "PopoverMessage",
  componentId: "sc-1subuq1-0"
})(_templateObject, _buoyTheme.fontFamily, _buoyTheme.fontWeight.light, (0, _buoyTheme.fontSize)('bodySmall'), _buoyTheme.colors.neutralDark, function (props) {
  return props.show ? 'visible' : 'hidden';
}, function (props) {
  return props.position.x ? "translateX(" + props.position.x + "px)" : "translateX(-50%)";
}, function (props) {
  return props.position.down && (0, _styledComponents.css)(_templateObject2);
});

exports.default = PopoverMessage;


//////////////////
// WEBPACK FOOTER
// ./~/buoy-popover/dist/PopoverMessage.js
// module id = 436
// module chunks = 168707334958949